import type { SpinnerProps } from "react-bootstrap";

import React from "react";
import { Spinner as BsSpinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export interface ILoadingProps extends Omit<SpinnerProps, "size"> {
  size?: "sm" | "lg";
}

function Loading({
  animation = "border",
  size = "sm",
  ...props
}: ILoadingProps) {
  const { t } = useTranslation();
  const isStandardSize = size === "sm";

  return (
    <BsSpinner
      role="status"
      animation={animation}
      size={isStandardSize ? "sm" : undefined}
      {...props}
    >
      <span className="visually-hidden">{t("events.loading")}</span>
    </BsSpinner>
  );
}

export default Loading;
